export const innerBoxTextStyles = {
  marginTop: '2px',
};

export const titleStyles = {
  display: 'block',
  fontFamily: 'Overpass',
  fontSize: 16.54,
  fontWeight: 600,
  letterSpacing: 0.15,
  lineHeight: '24px',
};
